import React, { useState, useEffect, useContext } from 'react';
import { Tab, TabProps, Dimmer, Loader, Button } from 'semantic-ui-react';
import queryString from 'query-string';

import SignUpComponent from '../../components/signUpComponent';
import LoginComponent from '../../components/loginComponent';
import * as Authentication from '../../../services/Authentication';
import * as Database from '../../../services/db';
import * as User from '../../../services/User';

import './style.less';
import ConnectedResident from '../../components/connectedResident';
import UserContext from '../../../contexts/UserContext';
import RedirectContext from '../../../contexts/RedirectContext';
import config from '../../../config';

const LogIn = (props) => {
    const queryParams = queryString.parse(props.location.search);


    const haveLoggedInBefore = localStorage.getItem('haveLoggedInBefore');

    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [code, setCode] = useState<string>('');

    const [activeIndex, setActiveIndex] = useState<number>(queryParams.signup ? 1 : haveLoggedInBefore ? 0 : 1);

    const [disabledButton, setDisabledButton] = useState<boolean>(queryParams.signup ? true : false);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [signUpError, setSignUpError] = useState<string>('');
    const [logInError, setLogInError] = useState<string>('');

    const { setUser } = useContext(UserContext);
    const toggleRedirect = useContext(RedirectContext);

    const env = process.env.SERVER_ENV || 'development';
    const envConfig = config[env];

    const handleLoginSubmit = async (
        e: React.MouseEvent<HTMLDivElement, MouseEvent>,
        username: string,
        password: string,
        newSignup: boolean = false,
    ): Promise<void> => {
        e.preventDefault();

        setLoading(true);

        try {
            // Validate if the username (contact) is a valid US phone number
            const numberRegExp = /^\+1\d{10}$/; // Ensure it starts with +1 and is a valid 10-digit US number
            if (!numberRegExp.test(username)) {
                setLogInError('Invalid contact. Please enter a valid US phone number starting with +1.');
                setLoading(false);
                return;
            }
            const user = await Authentication.cognitoSignIn(username, password);
            console.log('username', user);
            const dbUserProfileResponse = await Database.getUserDbProfile();
            const userProfile = dbUserProfileResponse.userProfile;

            const connectedRegistrants = await Database.getRelatedRegistrants();

            const signedInUser = {
                cognitoUser: user,
                profile: userProfile,
                registrants: {
                    list: connectedRegistrants.residents,
                    activeRegistrantsIndexes:
                        connectedRegistrants.residents && connectedRegistrants.residents.length ? [0] : [],
                },
                username: user.username,
                authenticated: true,
            };

            if (!userProfile) throw Error('No user profile');
            setUser(signedInUser);
            if (newSignup && connectedRegistrants.residents && connectedRegistrants.residents.length === 0) {
                toggleRedirect('/message-recipients');
            } else {
                if (process.env.REACT_APP_PLATFORM === 'community') {
                    toggleRedirect('/send-message');    
                }
                else {
                    toggleRedirect('/activities');
                }
            }
            return;
        } catch (error) {
            console.log(error.message);
            const userExists = await Authentication.checkIfUserExists(username);
            if (!userExists) {
                setLogInError('User does not exist');
            } else {
                setLogInError('Unable to log in.');
            }
            setLoading(false);
        }
    };

    const handleSignUpSubmit = async (
        e: React.MouseEvent<HTMLDivElement, MouseEvent>,
        contact: string,
        password: string,
    ): Promise<any> => {
        e.preventDefault();

        setLoading(true);

        // if (!token || !registrantId || !receivedContact) {
        //     setSignUpError('Unauthorized registration attempt');
        // }
        const signUpParams = { password, firstName, lastName };

        if (code) {
            // @ts-ignore
            signUpParams.token = code;
        }

        // @ts-ignore
        signUpParams.contact = contact;

        try {
            console.log('signup params,', signUpParams);
            await Authentication.cognitoSignUp(signUpParams);

            handleLoginSubmit(e, contact, password, true);
            return;
        } catch (error) {
            setLoading(false);
            const errObj: any = error; // error object does not have response property so we convert it to any
            if (errObj && errObj.response && errObj.response.data && errObj.response.data.message) { // This is to get the custom error message that the backend sends so that we can show it to the user on frontend
                setSignUpError(errObj.response.data.message);
            }
            else if (errObj.message) {
                setSignUpError(errObj.message);
            }
            else {
                setSignUpError('Unable to sign up');
            }
        }
    };

    const toggleLoginOrSignup = () => {
        if (loginOrSignup === 'login') {
            setLoginOrSignup('signup')
        } else {
            setLoginOrSignup('login')
        }
    }

    const handleTabChange = (_: React.MouseEvent<HTMLDivElement, MouseEvent>, data: TabProps): void => {
        console.log(data);
        if (data.activeIndex === 0) {
            setActiveIndex(0);
        }
        if (data.activeIndex === 1) {
            setActiveIndex(1);
        }
    };

    const panes = [
        {
            menuItem: 'Log In',
            render: () => (
                <Tab.Pane className="login-pane">
                    <LoginComponent handleLoginSubmit={handleLoginSubmit} error={logInError} />
                </Tab.Pane>
            ),
        },
        {
            menuItem: 'Sign Up',
            render: () => (
                <Tab.Pane className="signup-pane">
                    <SignUpComponent
                        firstName={firstName}
                        lastName={lastName}
                        setFirstName={setFirstName}
                        setLastName={setLastName}
                        setCode={setCode}
                        handleSignUpSubmit={handleSignUpSubmit}
                        error={signUpError}
                        disabledButton={disabledButton}
                    />
                </Tab.Pane>
            ),
        },
    ];

    // useEffect(() => {
    //     if (token) {
    //         User.userAlreadyExists(receivedContact)
    //             .then((response) => {
    //                 if (response) {
    //                     setActiveIndex(0);
    //                     setLoading(false);
    //                     return false;
    //                 }
    //             })
    //             .catch((error) => {
    //                 Authentication.ConfirmToken(token, registrantId)
    //                     .then((response) => {
    //                         setLoading(false);
    //                         if (response) setDisabledButton(false);
    //                         if (!response) setError('Could not validate your credentials.');
    //                     })
    //                     .catch((error) => {
    //                         setLoading(false);
    //                         setError('Could not validate your credentials.');
    //                     });
    //             });
    //     }
    //     setLoading(false);
    // }, [token, registrantId, receivedContact]);

    const [loginOrSignup, setLoginOrSignup] = useState('login')
    const CommunityLoginOrSignUpComponent = () => {
        if (!loading) {
            if (loginOrSignup === 'login') {
                return <LoginComponent handleLoginSubmit={handleLoginSubmit} error={logInError} locationState={props.location.state}/>
            } else if (loginOrSignup === 'signup') {
                return (
                    <div>
                        <SignUpComponent
                            firstName={firstName}
                            lastName={lastName}
                            setFirstName={setFirstName}
                            setLastName={setLastName}
                            setCode={setCode}
                            handleSignUpSubmit={handleSignUpSubmit}
                            error={signUpError}
                            disabledButton={disabledButton}
                        />
                        <div style={{textAlign: 'center'}}>
                            <br />
                            <a className="text-center" onClick={toggleLoginOrSignup} style={{cursor: 'pointer'}}>Back to Login</a>
                        </div>
                    </div>
                )
            }
        }
    }

    const CommunitySignupButton = () => {
        if (loginOrSignup === 'login') {
            return (
                <div className="signup-container">
                    If you don't have an account
                    <Button className="signup-button" onClick={toggleLoginOrSignup} role="link" color="teal" basic>
                        Sign Up
                    </Button>
                </div>
            )
        } else if (loginOrSignup === 'signup') {
            return ''
        }
    }

    const CommunityAppLinksComponent = () => {
        if (!loading) {
            return (
                <div className="app-links">
                    <a
                        href="https://play.google.com/store/apps/details?id=com.speak2software.community"
                        className="play-store"
                    >
                        <img
                            alt="Get it on Google Play"
                            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                        />
                    </a>
                    <a href="https://apps.apple.com/ua/app/speak2-community/id1596060585" className="app-store">
                        <img src="/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" />
                    </a>
                </div>
            )
        }
    }

    return (
        <div className="login-wrapper">
            <Dimmer active={loading} inverted>
                <Loader active={loading} />
            </Dimmer>
            {process.env.REACT_APP_PLATFORM === 'community'
            ?   <img src={`${process.env.PUBLIC_URL}/logo-speak2-community.svg`} alt="Speak 2 Community Logo" className="logo" />
            :   <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Speak 2 Family Logo" className="logo" />
            }
            
            {process.env.REACT_APP_PLATFORM === 'community'
            ?   CommunityLoginOrSignUpComponent()
            :   <LoginComponent handleLoginSubmit={handleLoginSubmit} error={logInError} locationState={props.location.state}/>   
            }

            {process.env.REACT_APP_PLATFORM === 'community'
            ?   CommunitySignupButton()
            :   <div className="signup-container">
                    If you don't have an account
                    <Button className="signup-button" href={envConfig.signUpUrl} role="link" color="teal" basic>
                        Sign Up
                    </Button>
                </div>

            }
            
            <h4 className="text-center">The app is available for download</h4>
            {process.env.REACT_APP_PLATFORM ==='community'
            ?   CommunityAppLinksComponent()

            :   <div className="app-links">
                    <a
                        href="https://play.google.com/store/apps/details?id=com.speak2software.family&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                        className="play-store"
                    >
                        <img
                            alt="Get it on Google Play"
                            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                        />
                    </a>
                    <a href="https://apps.apple.com/us/app/speak2-family/id1503580779" className="app-store">
                        <img src="/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" />
                    </a>
                </div>
            }
        </div>
    );
};

function getDecodedUrlSegments(params) {
    try {
        let {
            t: token,
            r: registrantId,
            c: receivedContact,
            f: registrantFirstName,
            l: registrantLastName,
            i: image,
        } = params;
        return {
            token: atob(token || ''),
            registrantId: atob(registrantId || ''),
            receivedContact: atob(receivedContact || ''),
            registrantFirstName: atob(registrantFirstName || ''),
            registrantLastName: atob(registrantLastName || ''),
            // image: 'https://' + atob(image || ''),
            image: image ? 'https://' + atob(image) : undefined,
        };
    } catch (error) {
        return {
            token: '',
            registrantId: '',
            receivedContact: '',
            registrantFirstName: '',
            registrantLastName: '',
            image: '',
        };
    }
}

export default LogIn;
